import { ApiError } from '@/core/api/http'

export function isUniqueViolation(error: unknown): boolean {
  return error instanceof ApiError && error.status === 409
}

function isPublicMessage(message: string): boolean {
  return /(?:^(?:Der|Die|Das|Diese[rs]?|Es|Eine?|Kein[ers]?)\b|\b(?:Bitte|Sie|Ihre?|konnte|konnten|fehlt|fehlen|fehlgeschlagen|erforderlich|vorhanden|hinterlegt|bereits|nicht|Nur)\b|[äöüÄÖÜß])/.test(message)
    && !/(?:[a-z0-9_-]+\/)+[a-z0-9_.-]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}|https?:\/\/|\b(?:SQLSTATE|PGRST\w*|Traceback|Exception|SELECT|INSERT|UPDATE|DELETE|constraint)\b|\w*Error:/i.test(message)
}

export function friendlyErrorMessage(error: unknown, fallback: string): string {
  const message = error instanceof ApiError
    ? error.detailText
    : (error as { message?: string } | null)?.message ?? ''
  if (/^no Informationsblatt on record(?: at .+)?$/.test(message)) {
    return 'Das Informationsblatt Ihrer Organisation fehlt. Bitte bitten Sie die Organisationsverwaltung, es in den Organisationseinstellungen hochzuladen.'
  }
  if (error instanceof ApiError && error.path === '/portal/participant-link') {
    const detail = error.detailText
    if (error.status === 503 && detail === 'no mail transport configured') return 'Der E-Mail-Versand ist nicht eingerichtet. Bitte wenden Sie sich an die Organisationsverwaltung.'
    if (error.status === 422 && detail === 'no email on file for this participant') return 'Für diese Person ist keine E-Mail-Adresse hinterlegt. Bitte ergänzen Sie die E-Mail-Adresse in den Stammdaten.'
    if (error.status === 422 && /^the recipient address .+ was refused by the mail server$/.test(detail)) return 'Der E-Mail-Server hat die Empfängeradresse abgelehnt. Bitte prüfen Sie die E-Mail-Adresse.'
    if (error.status === 409 && detail === 'an invite for this step is already pending') return 'Für diesen Schritt wurde bereits ein Link gesendet. Bitte verwenden Sie „Erinnerung senden“.'
    if (error.status === 404) return 'Der Teilnehmer-Link ist für Sie nicht verfügbar.'
    if (error.status === 401) return 'Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an.'
    if (error.status === 403) return 'Der Server hat den Link-Versand abgelehnt. Bitte laden Sie die Seite neu.'
    if (error.status === 429) return 'Zu viele Versuche. Bitte warten Sie kurz und versuchen Sie es erneut.'
    if (error.status >= 500) return 'Der Link-Versand ist wegen eines Serverfehlers fehlgeschlagen. Bitte versuchen Sie es erneut.'
  }
  if (error instanceof ApiError) {
    if (error.status === 401) return 'Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an.'
    if (error.status >= 500) return /Bitte\b/.test(fallback) ? fallback : `${fallback} Bitte versuchen Sie es später erneut.`
    if (isPublicMessage(message)) return message
    if (error.status === 403) return 'Sie haben keine Berechtigung für diese Aktion. Bitte wenden Sie sich an die Organisationsverwaltung.'
    if (error.status === 413) return 'Die Datei ist zu groß. Bitte laden Sie eine kleinere Datei hoch.'
    if (error.status === 429) return 'Zu viele Versuche. Bitte warten Sie kurz und versuchen Sie es erneut.'
    return fallback
  }
  return isPublicMessage(message) ? message : fallback
}
